import { TableHead, TableRow, TableCell } from '@mui/material';

export default function AddonsTableHead() {
  return (
    <TableHead>
      <TableRow>
        <TableCell>Image</TableCell>
        <TableCell>Title</TableCell>
        <TableCell>Status</TableCell>
        {/* <TableCell>Text</TableCell> */}
        <TableCell>Downloads</TableCell>
        <TableCell align="right">Actions</TableCell>
        <TableCell align="right">Notification</TableCell>
      </TableRow>
    </TableHead>
  );
}
